export default "__VITE_ASSET__4dc08d96__"